/**
 * A utility function for locally updating a constituent's board positions.
 * The `boards` attribute on a constituent should be read-only from the API, but
 * there is a bit of a delay between creating a board position <> constituent
 * relationship and the positon actually showing up on the constituent's
 * `boards` array. To make interaction with boards more seamless for the user,
 * this utility function updates the local copy of a constituent with any
 * changes to board position - a column update.
 * @param {Object} constituent - constituent to update
 * @param {Object} boardPosition - updated boardPosition
 * @param {string} boardPosition.boardId
 * @param {string} boardPosition.columnId
 * @returns {Object} updated constituent record
 */
const getUpdatedBoardPosition = (constituent, boardPosition) => {
  const boards = [];
  let foundMatchingBoard = false;
  (constituent.boards || []).forEach((oldBoardPosition) => {
    if (oldBoardPosition.boardId === boardPosition.boardId) {
      foundMatchingBoard = true;
      boards.push({ ...oldBoardPosition, ...boardPosition });
    } else {
      boards.push(oldBoardPosition);
    }
  });
  if (!foundMatchingBoard) {
    boards.push(boardPosition);
  }
  return {
    ...constituent,
    boards,
  };
};

export default getUpdatedBoardPosition;
